import React from "react";
import { useTranslation } from "react-i18next";

const EmailForm = ({ email, setEmail, error, onBlur }) => {
  const { t } = useTranslation();

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  return (
    <div className="form-group" style={{ width: "100%" }}>
      <label htmlFor="email" className="form-label">
        {t("hireaiexpertmodal.businessemail")}
      </label>

      <input
        type="email"
        name="email"
        id="email"
        autoComplete="email"
        className={`form-control form-inputs ${error ? "is-invalid" : ""}`}
        value={email}
        onChange={handleChange}
        onBlur={onBlur}
        required
        aria-invalid={!!error}
      />

      {error && (
        <small className="form-text text-danger">
          {error}
        </small>
      )}
    </div>
  );
};

export default EmailForm;